import * as i0 from '@angular/core';
import { forwardRef, Component, Input, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

class ToggleSwitchComponent {
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this.checkedColor = 'btn-primary';
        this.uncheckedColor = 'btn-default';
        this.labelBefore = '';
        this.labelAfter = '';
        this._checked = false;
        this.propagateChange = () => { };
    }
    get colorClasses() {
        const colors = {};
        colors[this.checkedColor] = this.checked;
        colors[this.uncheckedColor] = !this.checked;
        return colors;
    }
    get checked() {
        return this._checked;
    }
    set checked(value) {
        if (value !== this.checked) {
            this._checked = value;
            this._changeDetectorRef.markForCheck();
            this.onChange(value);
        }
    }
    toggle() {
        this.checked = !this.checked;
    }
    writeValue(value) {
        this.checked = value;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) { }
    onChange(value) {
        this.propagateChange(value);
    }
    onFocus($event) {
        this.focused = true;
        this.element.nativeElement.focus();
    }
    onBlur($event) {
        this.focused = false;
        this.element.nativeElement.blur();
    }
}
ToggleSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: ToggleSwitchComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
ToggleSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.8", type: ToggleSwitchComponent, selector: "cc-toggle-switch", inputs: { checkedColor: "checkedColor", uncheckedColor: "uncheckedColor", labelBefore: "labelBefore", labelAfter: "labelAfter", checked: "checked" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleSwitchComponent),
            multi: true
        }
    ], viewQueries: [{ propertyName: "element", first: true, predicate: ["element"], descendants: true, static: true }], ngImport: i0, template: "<input type=\"checkbox\" [(ngModel)]=\"checked\" (focus)=\"onFocus($event)\" (blur)=\"onBlur($event)\" />\n<span [class.labelChecked]=\"!checked\" *ngIf=\"labelBefore\">{{labelBefore}}</span>\n<span #element class=\"switch mx-2\" [ngClass]=\"colorClasses\" [class.checked]=\"checked\" [class.focus]=\"focused\" (click)=\"toggle()\">\n    <small></small>\n    <span class=\"switch-text\"> </span>\n</span>\n<span [class.labelChecked]=\"checked\" *ngIf=\"labelAfter\">{{labelAfter}}</span>", styles: [":host{position:relative;display:inline-block;vertical-align:middle}.switch{position:relative;display:inline-block;box-sizing:content-box;vertical-align:middle;overflow:visible;width:52px;height:30px;padding:0;margin:0;border-radius:20px;cursor:pointer;top:-1px;border-style:solid;border-width:1px}.switch.focus{outline:0}.switch.btn-default{background:#fff;border:1px solid #dfdfdf}.switch.wide{width:80px}.switch small{background:#fff;border-radius:100%;box-shadow:0 1px 3px #0006;width:30px;height:30px;position:absolute;top:0;left:0;transition:.2s cubic-bezier(.4,0,.2,1) all;-webkit-transition:.2s cubic-bezier(.4,0,.2,1) all}.switch.checked small{left:22px}.switch.wide.checked small{left:52px}.switch .switch-text{font-family:Arial,Helvetica,sans-serif;font-size:13px}.switch .off{display:block;position:absolute;right:10%;top:25%;z-index:0;color:#a9a9a9}.switch .on{display:none;z-index:0;color:#fff;position:absolute;top:25%;left:9%}.switch.checked .off{display:none}.switch.checked .on{display:block}.switch.disabled{opacity:.5;cursor:not-allowed}input{width:0px;height:0px;top:-10000px;bottom:-10000px;position:absolute}.labelChecked{font-weight:700}\n"], dependencies: [{ kind: "directive", type: i1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: ToggleSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cc-toggle-switch', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => ToggleSwitchComponent),
                            multi: true
                        }
                    ], template: "<input type=\"checkbox\" [(ngModel)]=\"checked\" (focus)=\"onFocus($event)\" (blur)=\"onBlur($event)\" />\n<span [class.labelChecked]=\"!checked\" *ngIf=\"labelBefore\">{{labelBefore}}</span>\n<span #element class=\"switch mx-2\" [ngClass]=\"colorClasses\" [class.checked]=\"checked\" [class.focus]=\"focused\" (click)=\"toggle()\">\n    <small></small>\n    <span class=\"switch-text\"> </span>\n</span>\n<span [class.labelChecked]=\"checked\" *ngIf=\"labelAfter\">{{labelAfter}}</span>", styles: [":host{position:relative;display:inline-block;vertical-align:middle}.switch{position:relative;display:inline-block;box-sizing:content-box;vertical-align:middle;overflow:visible;width:52px;height:30px;padding:0;margin:0;border-radius:20px;cursor:pointer;top:-1px;border-style:solid;border-width:1px}.switch.focus{outline:0}.switch.btn-default{background:#fff;border:1px solid #dfdfdf}.switch.wide{width:80px}.switch small{background:#fff;border-radius:100%;box-shadow:0 1px 3px #0006;width:30px;height:30px;position:absolute;top:0;left:0;transition:.2s cubic-bezier(.4,0,.2,1) all;-webkit-transition:.2s cubic-bezier(.4,0,.2,1) all}.switch.checked small{left:22px}.switch.wide.checked small{left:52px}.switch .switch-text{font-family:Arial,Helvetica,sans-serif;font-size:13px}.switch .off{display:block;position:absolute;right:10%;top:25%;z-index:0;color:#a9a9a9}.switch .on{display:none;z-index:0;color:#fff;position:absolute;top:25%;left:9%}.switch.checked .off{display:none}.switch.checked .on{display:block}.switch.disabled{opacity:.5;cursor:not-allowed}input{width:0px;height:0px;top:-10000px;bottom:-10000px;position:absolute}.labelChecked{font-weight:700}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { checkedColor: [{
                type: Input
            }], uncheckedColor: [{
                type: Input
            }], labelBefore: [{
                type: Input
            }], labelAfter: [{
                type: Input
            }], element: [{
                type: ViewChild,
                args: ['element', { static: true }]
            }], checked: [{
                type: Input
            }] } });

class ToggleSwitchModule {
}
ToggleSwitchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: ToggleSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ToggleSwitchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: ToggleSwitchModule, declarations: [ToggleSwitchComponent], imports: [FormsModule, CommonModule], exports: [ToggleSwitchComponent] });
ToggleSwitchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: ToggleSwitchModule, imports: [FormsModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: ToggleSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [FormsModule, CommonModule],
                    declarations: [ToggleSwitchComponent],
                    exports: [ToggleSwitchComponent]
                }]
        }] });

/*
 * Public API Surface of toggle-switch
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ToggleSwitchComponent, ToggleSwitchModule };
